const IRouteService = require('../../IRouteService');
const Extend = require('../../../../base/util/Extend');
const CRSTransformUtil = require('../../../../utils/CRSTransformUtil');
const g2 = require('../../../../g2');
/**
 * @ignore
 * @classdesc 高德路径规划服务
 * @alias G.servicev2.RouteGaodeServiceImpl
 * @augments G.service.IRouteService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 * @param opts.token {String} 调用令牌
 */
class RouteGaodeServiceImpl extends IRouteService {
    constructor(opts) {
        super(opts);
        //
        this.opts = {};
        for (let k in opts) {
            this.opts[k] = opts[k];
        }
        //
        this.projectService = new g2.sfs.CoordinateTransform();
    }

    /**
     * @inheritdoc
     */
    driving(opts) {
        return new Promise(async(resolve, reject) => {
            let url = this._getUrl(this.opts.url, 'driving');
            url += `&key=${this.opts.token}`;
            opts.spatialReference = opts.spatialReference || 4326;
            let origin = this._getTransformedCoordiante(opts.origin, opts.spatialReference);
            url += `&origin=${origin[0]},${origin[1]}`;
            let destination = this._getTransformedCoordiante(opts.destination, opts.spatialReference);
            url += `&destination=${destination[0]},${destination[1]}`;
            if (opts.custom) {
                for (let kk in opts.custom) {
                    url += `&${kk}=${opts.custom[kk]}`;
                }
            }
            let data = await this.opts.httpRequest.get(url, 'json', null, 'application/x-www-form-urlencoded', {});
            if (data.info == 'OK') {
                let result = data.route.paths[0];
                let steps = result.steps;
                let allPoints = [];
                for (let i = 0; i < steps.length; i++) {
                    let pathLine = [];
                    let step = steps[i];
                    step.geometry = {
                            type: 'LineString',
                            coordinates: pathLine
                        }
                        //转换坐标
                    if (step.polyline) {
                        let pointStrList = step.polyline.split(';');
                        for (let jj = 0; jj < pointStrList.length; jj++) {
                            let pointStr = pointStrList[jj];
                            let transformed = CRSTransformUtil.gcj02towgs84(pointStr);
                            let pointXy = transformed.split(',');
                            let point = [parseFloat(pointXy[0]), parseFloat(pointXy[1])];
                            pathLine.push(point);
                            allPoints.push(point);
                        }
                    }
                    //转换路段坐标
                    if (step.tmcs) {
                        for (let kk = 0, len1 = step.tmcs.length; kk < len1; kk++) {
                            let tmc = step.tmcs[kk];
                            let polyline = tmc.polyline;
                            let tmcPoints = polyline.split(';'),
                                tmcPointArr = [];
                            for (let kkk = 0, len2 = tmcPoints.length; kkk < len2; kkk++) {
                                let pointStr = tmcPoints[kkk];
                                let transformed = CRSTransformUtil.gcj02towgs84(pointStr);
                                let pointXy = transformed.split(',');
                                tmcPointArr.push(pointXy);
                            }
                            tmc.polyline = tmcPointArr.join(';');
                        }
                    }
                }
                result.geometry = {
                    type: 'LineString',
                    coordinates: allPoints
                }
                resolve(result);
            } else {
                reject(new Error('路径规划失败：' + data.infocode));
            }
        });
    }



    //
    _getTransformedCoordiante(point, spatialReference) {
        let resultPoint = [];
        switch (spatialReference) {
            case 4326:
                {
                    let transformed = CRSTransformUtil.wgs84togcj02([point[0], point[1]].join(','));
                    resultPoint[0] = parseFloat(transformed.split(',')[0]).toFixed(6);
                    resultPoint[1] = parseFloat(transformed.split(',')[1]).toFixed(6);
                    break;
                }
            case 3857:
                {
                    let geom = new g2.sfs.Point({
                        x: pint[0],
                        y: point[1],
                        spatialReference: 3857
                    });
                    let geom4326 = this.projectService.transform(geom, 4326);
                    resultPoint = this._getTransformedCoordiante([geom4326.x, geom4326.y], 4326);
                    break;
                }
            default:
                {
                    break;
                }
        }
        return resultPoint;
    }

    //
    _getUrl(url, path) {
        let thisUrl = url;
        if (thisUrl.indexOf('/' + path) >= 0) {
            thisUrl = thisUrl.replace('/' + path, '');
        }
        if (thisUrl[thisUrl.length - 1] !== '/') {
            thisUrl += '/';
        }
        thisUrl += path;
        thisUrl += '?';
        return thisUrl;
    }

}
module.exports = RouteGaodeServiceImpl;